import validator from 'validator';
import notification from 'notification-js';

export default class Input {
  constructor(options) {
    this.onBlurCallback = options.onBlur;
    this.setupElement(options.element);
  }

  setupElement(element) {
    this.element = element;
    this.element.onfocus = this.onFocus.bind(this);
    this.element.onblur = this.onBlur.bind(this);
  }

  onFocus() {
    this.value = this.element.value;
  }

  onBlur(event) {
    if (validator.isNull(this.element.value)) {
      notification.notify( 'warning', 'This field should not be left empty the change has been reverted', {
        notification: {position: [ 'right', 'top' ]}
      });
      this.element.value = this.value;
      this.onBlurCallback(event);
    }
  }

  setElement(element) {
    this.setupElement(element);
  }

  getElement() {
    return this.element;
  }
}



// WEBPACK FOOTER //
// ./src/editors/editable/Input.js